import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class SessionService {
  myObservableArray: Observable<any[]> = new Observable<any[]>();

  constructor(private _router: Router) { }

  getSessionItems() {
    // let data = sessionStorage.getItem('token');
    let data = localStorage.getItem('token');
    if (data) {
      return JSON.parse(data);
    } else {
      this.logout();
    }
  }

  logout() {
  // Clear token
  localStorage.removeItem('token');

  // check current route
  const currentUrl = this._router.url;

  if (currentUrl.includes('/reset-password')) {
    // already on reset-password → stay here
    this._router.navigate(['/reset-password']);
  } else {
    // otherwise → go to signin
    this._router.navigate(['/signin']);
  }
}


  getUserDetails() {
    return this.getSessionItems()?.data?.user;
  }
  
  getPermissions() {
    // const data = sessionStorage.getItem('token');
    const data = localStorage.getItem('token');
    if (data) {
      const result = JSON.parse(data);
      if (result.data.user.userType === 'subadmin') {
        return result.data.user.roleData?.access || [];
      }
    }
    return []; // admin has implicit full access
  }


  get getRolePath() {
    const user = this.getUserDetails();
    return user.userType === 'admin' ? '' : user.userType === 'subadmin' ? 'subadmin' : '';
  }
}
